import styled from "styled-components";
import { TextM } from "../../../../components/Elements";

export const Container = styled.div`
  padding-top: 22px;
`;

export const ContentWrap = styled.div`
  padding-bottom: 22px;
`;

export const SubTitle = styled.div`
  ${({ theme }) => theme.textStyles.content2};
  color: ${({ theme }) => theme.colors.prune};
  font-family: "OpenSans SemiBold";

  @media only screen and (max-width: 560px) {
    font-size: 15px;
  }
`;

export const CustomTextM = styled(TextM)`
  span.highlight {
    color: ${({ theme }) => theme.colors.prune};
  }
`;
